import { Icons, Button, styled } from '@/theme/index';

interface MonitoringUnclaimedReportButtonProps {
  handleSetIsMonitored: () => void;
  isMonitored?: boolean;
}

const CustomButton = styled(Button)(() => ({
  height: '32px',
  padding: '10px 8px',
  width: '100%',
  fontSize: '14px',
  maxWidth: '140px',
  gap: '3px',
}));

export const MonitorReportButton = ({
  handleSetIsMonitored,
  isMonitored,
}: MonitoringUnclaimedReportButtonProps) => {
  return (
    <CustomButton
      className="MonitorReportButton"
      onClick={handleSetIsMonitored}
      sx={{
        ...(isMonitored && {
          color: '#4968B4',
          backgroundColor: 'white',
        }),
        ...(!isMonitored && {
          color: 'white',
          backgroundColor: '#4968B4',
        }),
      }}
    >
      {isMonitored ? (
        <>
          <Icons.CheckRounded
            color="inherit"
            sx={{
              width: '18px',
              height: '18px',
            }}
          />
          Monitoring
        </>
      ) : (
        <>
          <Icons.NotificationsOutlined
            color="inherit"
            sx={{
              width: '18px',
              height: '18px',
            }}
          />
          Monitor
        </>
      )}
    </CustomButton>
  );
};
